import {collection, doc, query, where, db, setDoc, getDocs} from '../FirebaseInit'

export const postReview = async ({id, userRef, comment}) => {

  return new Promise(async (res, rej) => {
    try {
      await setDoc(doc(collection(db, 'review')), {
        id: id,
        review: comment,
        user_name: userRef.displayName,
      }).catch(e => {
        console.log(e.message);
      })
      res({
        id: id,
        review: comment,
        user_name: userRef.displayName,
      });
    } catch (e) {
      console.log(e.message);
      rej(e.message);
    }
  })

};

export const reviewList = (id) => {
  console.log(id);
  return new Promise(async(res, rej) => {
    try {
      const docRef = collection(db, 'review');
      const docs = query(docRef, where('id', "==", id));
      const querySnapShot = await getDocs(docs);
      let list = [];
      querySnapShot.forEach(doc => {
        list.push({...doc.data()});
        console.log(doc.data());
      });
      res(list)
    } catch (e) {
      console.log(e.message);
      rej(e.message)
    }
  })
 
}